<template>
  <router-view />
</template>

<script>
export default {
  name: "app-doorType"
};
</script>

<style lang="scss" scoped></style>
